import { render, staticRenderFns } from "./GroupInfoEditPage.vue?vue&type=template&id=76e381cc&"
import script from "./GroupInfoEditPage.vue?vue&type=script&lang=ts&"
export * from "./GroupInfoEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports